module.exports = __webpack_public_path__ + "static/media/ic_canvas_deactivate.f53628ac.svg";